<template>
    <div class="wizard-progress">
        <div class="steps">
            <div v-for="(step, index) in steps" class="step" :class="{active: index === current, passed: current > index }">
                <a href="" @click.prevent.stop="goto(index)" :title="title(index)">{{ index + 1 }}</a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "WizardProgress",
    props:{
        steps: {
            type: [Array],
            default: ['step'],
        },
        current: {
            type: Number,
            default: 0,
        },
        forward: {
            type: Boolean,
            default: true,
        },
        backward: {
            type: Boolean,
            default: true,
        }
    },

    methods:{
        title(index){
            const step = this.steps[ index ];
            if( typeof step === 'string' || typeof step === 'number' ){
                return step;
            }
            if( typeof step === 'object' && typeof step.name !== 'undefined' ){
                return step.name;
            }
            return index;
        },

        goto(index){

        }

    }

}
</script>

<style lang="scss" scoped>
.steps{
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;

    &:before{
        content: '';
        position: absolute;
        left: 0;
        right: 0;
        top: 50%;
        height: 0;
        transform: translateY(-50%);
        border-bottom: rgba($dark, 0.1) solid 1px;
        z-index: 1;
    }
}
.step{
    position: relative;
    z-index: 2;

    a{
        display: flex;
        align-items: center;
        justify-content: center;
        width: 20px;
        height: 20px;
        background: lighten($dark, 50%);
        border: lighten($dark, 40%) solid 2px;
        border-radius: 50%;
        box-shadow: rgba(black, 0.1);
        color: white;
        font-size: 0.875rem;
        text-decoration: none;
    }

    &.active{
      a{
          background: $primary;
          border-color: darken($primary, 5%);
      }
    }

    &.passed{
      a{
          background: $success;
          border-color: darken($success, 5%);
      }
    }
}
</style>
